import { clsx } from 'clsx'
import type { NLParseResult } from '@/lib/nlParser'

interface NlHintChipsProps {
  /** parseNaturalLanguage()의 반환값. 추출된 항목이 없으면 null을 렌더 */
  parsed: NLParseResult | null
  className?: string
}

/**
 * 자연어 파싱 결과를 📅 날짜 / 🕐 시간 / 🔔 우선순위 칩으로 표시.
 * 인라인 빠른 추가(TaskList)와 상세 모달(TaskCreateModal)에서 공유하여
 * 동일한 칩 스타일을 한 곳에서 관리한다. 추출된 항목이 없으면 null.
 */
export function NlHintChips({ parsed, className }: NlHintChipsProps) {
  if (!parsed || (!parsed.dueDate && !parsed.dueTime && !parsed.priority)) {
    return null
  }

  return (
    <div className={clsx('flex items-center gap-1.5 flex-wrap', className)}>
      {parsed.dueDate && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400">
          📅 {parsed.dueDate}
        </span>
      )}
      {parsed.dueTime && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400">
          🕐 {parsed.dueTime}
        </span>
      )}
      {parsed.priority && parsed.priority !== 'none' && (
        <span
          className={clsx(
            'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs',
            parsed.priority === 'high' && 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400',
            parsed.priority === 'medium' && 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400',
            parsed.priority === 'low' && 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400'
          )}
        >
          🔔 {parsed.priority === 'high' ? '높음' : parsed.priority === 'medium' ? '중간' : '낮음'}
        </span>
      )}
    </div>
  )
}
